import type { FollowupData } from '@common/validation/customControls/osas/osasTreatmentChoice/types';
import { CpapClassOption, MraAbcdScore, SptClassOption } from '@common/enums';
import { FollowupPerformer } from '@common/validation/customControls/osas/osasTreatmentChoice/types';

export type TreatmentDescription = {
    extraInformation: string[];
    followUp: FollowupData[];
    label: string;
};

export type TreatmentOptions = {
    CPAP: TreatmentDescription[];
    lifestyle: TreatmentDescription[];
    MRA: TreatmentDescription[];
    other: TreatmentDescription[];
    refer: TreatmentDescription[];
    SPT: TreatmentDescription[];
};

export type TreatmentOptionsKeys = keyof TreatmentOptions;

export const treatmentOptions: TreatmentOptions = {
    CPAP: [
        {
            extraInformation: [
                'Geen begeleiding van de OSAS consulent nodig.',
                'Stopverklaring of akkoordverklaring in het portaal van de leverancier wordt uitgevoerd door de polikliniek medewerker bij het verwerken van het spreekuur na “vervolgconsult” volgens ingevuld beleid.',
            ],
            followUp: [
                {
                    performer: FollowupPerformer.medicalSpecialist,
                    weeks: 6,
                },
            ],
            label: CpapClassOption.CpapClassA,
        },
        {
            extraInformation: [
                'De OSAS consulent voert na 4-6 weken een controle consult uit.',
                'Indien de therapie goed gaat kan de OSAS consulent de CPAP-therapie akkoord geven.',
            ],
            followUp: [
                {
                    performer: FollowupPerformer.osasConsultant,
                    weeks: 6,
                },
            ],
            label: CpapClassOption.CpapClassB,
        },
        {
            extraInformation: [
                'De OSAS consulent voert na 4-6 weken een controle consult uit.',
                'Indien de therapie goed gaat meldt de OSAS-verpleegkundige de CPAP-therapie akkoord.',
                'Indien er problemen zijn of bij twijfel dan alsnog in week 8 een consult met de medisch specialist inplannen.',
            ],
            followUp: [
                {
                    performer: FollowupPerformer.osasConsultant,
                    weeks: 6,
                },
            ],
            label: CpapClassOption.CpapClassC,
        },
        {
            extraInformation: [
                'De OSAS consulent voert na 4-6 weken een controle consult uit.',
                'Na 8 weken wordt er een consult ingepland met de medisch specialist.',
            ],
            followUp: [
                {
                    performer: FollowupPerformer.osasConsultant,
                    weeks: 6,
                },
                {
                    performer: FollowupPerformer.medicalSpecialist,
                    weeks: 8,
                },
            ],
            label: CpapClassOption.CpapClassD,
        },
    ],

    MRA: [
        {
            extraInformation: ['Na 3 maanden vervolgconsult met medisch specialist, indien gewenst door patiënt.'],
            followUp: [
                {
                    hide: true,
                    performer: FollowupPerformer.medicalSpecialist,
                    weeks: 16,
                },
            ],
            label: MraAbcdScore.A,
        },
        {
            extraInformation: ['Na 3 maanden vervolgconsult met medisch specialist, geen controle slaaponderzoek.'],
            followUp: [
                {
                    hide: true,
                    performer: FollowupPerformer.medicalSpecialist,
                    weeks: 16,
                },
            ],
            label: MraAbcdScore.B,
        },
        {
            extraInformation: ['Na 3 maanden controle slaaponderzoek en een vervolgconsult met medisch specialist.'],
            followUp: [
                {
                    hide: true,
                    performer: FollowupPerformer.medicalSpecialist,
                    weeks: 16,
                },
            ],
            label: MraAbcdScore.C,
        },
        {
            extraInformation: ['Na 3 maanden controle slaaponderzoek en een vervolgconsult met medisch specialist.'],
            followUp: [
                {
                    hide: true,
                    performer: FollowupPerformer.medicalSpecialist,
                    weeks: 16,
                },
            ],
            label: MraAbcdScore.D,
        },
    ],
    SPT: [
        {
            extraInformation: ['Begeleiding door OSAS consulent. Indien nodig vervolgconsult met medisch specialist.'],
            followUp: [
                {
                    hide: true,
                    performer: FollowupPerformer.osasConsultant,
                    weeks: 6,
                },
            ],
            label: SptClassOption.SptClassA,
        },
        {
            extraInformation: [
                'Begeleiding door OSAS consulent. Na 3 maanden vervolgonderzoek en een vervolgconsult met medisch specialist.',
            ],
            followUp: [
                {
                    hide: true,
                    performer: FollowupPerformer.osasConsultant,
                    weeks: 6,
                },
            ],
            label: SptClassOption.SptClassB,
        },
    ],
    lifestyle: [],
    other: [],
    refer: [],
} as const;
